var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8295 28.5687L45.3512 28.0197L36.5726 43.7281L16.7377 43.8533L16.3793 37.8821L33.0057 37.55L41.7843 21.8416L62.4711 22.5975L62.8295 28.5687ZM72.3015 44.3801L54.5657 43.9798L46.302 59.3909L26.4671 59.5161L26.1087 53.5449L42.7351 53.2128L50.9988 37.8017L71.943 38.4089L72.3015 44.3801ZM81.6646 60.5976L63.9289 60.1973L55.6652 75.6084L35.8303 75.7336L35.4718 69.7624L52.0982 69.4303L60.362 54.0192L81.3062 54.6264L81.6646 60.5976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.3384,
    height: 71.3384,
    fill: "white",
    transform: "translate(61.7808) rotate(60)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideIcon1);
export default __webpack_public_path__ + "static/media/side-icon-1.cd934c4a4fc45f3ec2eb2b9b14686733.svg";
export { ForwardRef as ReactComponent };